import { fetchWithAuth } from "@/providers/auth-provider";
import { ServiceResponse } from "@/types/services";
import { GetCollectionsOutput } from "types/web-app";

export const getCollections = async (accessToken: string) => {
  try {
    const response = await fetchWithAuth("/collection/list", accessToken);
    const data = (await response.json()) as ServiceResponse<GetCollectionsOutput>;
    return data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};
